import { useEffect, useState } from 'react';

import { useConfigProvider } from '@/providers/ConfigProvider';

export const useHeaderOffSet = () => {
  const { headerRef } = useConfigProvider();
  const [top, setTop] = useState<number>(0);

  useEffect(() => {
    if (!headerRef?.current) return;

    const observer = new ResizeObserver(() => {
      setTop(
        headerRef.current ? Math.floor(headerRef.current.offsetHeight) : 0,
      );
    });

    observer.observe(headerRef.current);

    setTop(headerRef.current ? Math.floor(headerRef.current.offsetHeight) : 0);

    return () => {
      observer.disconnect();
    };
  }, [headerRef]);

  return top;
};
